import React from 'react';
import Row from 'react-bootstrap/Row';
import classnames from 'classnames';

import Button from '@components/Button';
import Input from '@components/Input';
import ModalBase from '@components/ModalBase';

import './style.scss';

export interface ICitizenAuth0ModalProps {
  show: boolean;
  onClose: (e: React.SyntheticEvent<any>) => void;
  onSubmit: (ssoRequest: ICitizenAuth0Request) => void;
  citizenAuth0: ICitizenAuth0Response;
}

interface ICitizenAuth0ModalState {
  citizenAuth0: ICitizenAuth0Request;
}

class CitizenAuth0Modal extends React.Component<ICitizenAuth0ModalProps, ICitizenAuth0ModalState> {
  constructor(props: ICitizenAuth0ModalProps) {
    super(props);

    this.state = this.getEmptyState();
  }

  getEmptyState = (): ICitizenAuth0ModalState => ({
    citizenAuth0: {
      isActive: false,
      type: ConfigExternalServiceIntegrationOption.CITIZEN_AUTH0,
    },
  });

  componentDidUpdate(prevProps: ICitizenAuth0ModalProps) {
    const hasOpened = this.props.show !== prevProps.show && this.props.show;
    const isEdit = !!this.props.citizenAuth0;

    if (hasOpened) {
      if (isEdit) {
        this.setState({
          citizenAuth0: {
            ...this.props.citizenAuth0,
            type: ConfigExternalServiceIntegrationOption.CITIZEN_AUTH0,
          },
        });
      } else {
        this.setState(this.getEmptyState());
      }
    }
  }

  onSubmit = (e: React.SyntheticEvent<HTMLButtonElement>) => {
    this.props.onSubmit(this.getRequestFromState());
  };

  getRequestFromState = (): ICitizenAuth0Request => {
    const { isActive, type } = this.state.citizenAuth0;

    return {
      isActive,
      type,
    };
  };

  handleChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const { name, value } = e.currentTarget;
    this.setState((prevState) => ({
      ...prevState,
      citizenAuth0: {
        ...prevState.citizenAuth0,
        [name]: value,
      },
    }));
  };

  renderTitle = () =>
    this.props.citizenAuth0?.id
      ? 'Edit CRM Citizen Authentication: Auth0-SSO'
      : 'CRM/Citizen Authentication: Auth0-SSO';

  renderBody = () => {
    const citizenAuth0StatusOptions = [
      { value: true, label: 'Active' },
      { value: false, label: 'Inactive' },
    ];

    const { citizenAuth0 } = this.state;

    return (
      <div className={classnames('integration__body')}>
        <Row>
          <Input
            width={4}
            field={{
              label: 'Status',
              type: OtherFieldType.RADIOBUTTON,
              value: citizenAuth0.isActive,
              isRequired: true,
            }}
            name="isActive"
            valueLabelOptions={citizenAuth0StatusOptions}
            onChange={this.handleChange}
          />
        </Row>
      </div>
    );
  };

  renderFooter = () => {
    const submitBtnTxt = this.props.citizenAuth0 ? 'Save' : 'Add Integration';

    return (
      <div className={classnames('integration__footer')}>
        <Button bsStyle={ButtonStyle.DEFAULT} onClick={this.props.onClose} content="Cancel" />
        <Button bsStyle={ButtonStyle.PRIMARY} onClick={this.onSubmit} content={submitBtnTxt} />
      </div>
    );
  };

  render() {
    return (
      <ModalBase
        show={this.props.show}
        onClose={this.props.onClose}
        titleElement={this.renderTitle()}
        bodyElement={this.renderBody()}
        footerElement={this.renderFooter()}
        className={classnames('integration-modal')}
      />
    );
  }
}

export default CitizenAuth0Modal;
